/**
 * Sla Feriado
 * @author Thacryba
 */
import {$, HttpBody, ID, IResource, Resource, ResponseFill, ResponseSerialize, TAG} from 'simpli-web-sdk'
import {
  ValidationMaxLength,
  ValidationRequired,
} from 'simpli-web-sdk'
import Responsavel from '@/model/resource/Responsavel'
import SlaHolidaysSchema from '@/schema/SlaHolidays.schema'
import moment from 'moment'
import {ItrackCollection} from '@/helpers'

export default class SlaFeriado extends Resource {
  get $schema() {
    return SlaHolidaysSchema(this)
  }

  get $id() {
    return this.idSlaFeriadoPk
  }
  set $id(val: ID) {
    this.idSlaFeriadoPk = val
  }
  get $tag() {
    return this.desc
  }
  set $tag(val: TAG) {
    this.desc = val
  }

  static async persistLoteTipoOcorrencia(listToPersist: SlaFeriado[], spinner = 'persistLoteTipoOcorrencia') {
    const fetch = async () => {
      return await new HttpBody(Number).POST(`/user/lote-tipo-ocorrencia`, listToPersist)
    }

    return await $.await.run(fetch, spinner)
  }

  readonly $name: string = 'SlaHolidays'

  readonly $endpoint: string = '/user/tipo-ocorrencia{/id}'

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel = new Responsavel()

  idSlaFeriadoPk: ID = 0

  dia: number = 0
  mes: number = 0

  @ValidationRequired()
  @ValidationMaxLength(100)
  desc: string = ''

  @ValidationRequired()
  ativo: boolean = true

  monthCollection = ItrackCollection.getMonthCollection()

  get date() {
    return moment().date(this.dia).month(this.mes - 1).format()
  }

  get dayCollection() {
    return ItrackCollection.getDayCollection(this.date)
  }

  get dayResource() {
    return this.dayCollection.get(this.dia)
  }
  set dayResource(val: IResource | null) {
    this.dia = val && val.$id as number || moment().date()
  }

  get monthResource() {
    return this.monthCollection.get(this.mes)
  }
  set monthResource(val: IResource | null) {
    this.mes = val && val.$id as number || moment().month()
  }

  async persistSlaFeriado(spinner = 'persistSlaFeriado') {
    const fetch = async () => {
      await this.validate()
      return await this.POST(`/user/sla-feriado`, this)
    }

    return await $.await.run(fetch, spinner)
  }

  async getSlaFeriado(id: ID, spinner = 'getSlaFeriado') {
    const fetch = async () => await this.GET(`/user/sla-feriado/${id}`)
    return await $.await.run(fetch, spinner)
  }

  async removeSlaFeriado(id: number | string, spinner = 'removeSlaFeriado') {
    const fetch = async () => await this.DELETE(`/user/sla-feriado/${id}`)
    return await $.await.run(fetch, spinner)
  }
}
